import { createLazyComponent } from '@muse-web/router'

export const AsyncCheckoutDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-checkout' */ './CheckoutDialogContainer'),
    'CheckoutDialogContainer',
)
